import {call, put, select, takeLatest} from "redux-saga/effects";
import {
  storeOrganizationAddress,
  storeScope,
  storeControllersForScope,
} from "../Actions/general.actions";
import {
  getOrganizationAddressAsync,
  requestScopeAsync,
  requestControllersForScopeAsync,
} from "../AsyncActions/general.async";
import {getOrganization} from "../Selectors/general.selectors";
import * as actions from "../action.constants";

function* getOrganizationAddress() {
  try {
    const organization = yield select(getOrganization);
    const response = yield call(getOrganizationAddressAsync, organization?.id);
    if (response) {
      yield put(storeOrganizationAddress(response?.data));
    }
  } catch (e) {
    //
  }
}

function* getScope(action = {}) {
  const {callback, customerId} = action;
  try {
    const response = yield call(requestScopeAsync, customerId);
    if (response?.data) {
      yield put(storeScope(response.data.results || []));
      if (callback) {
        callback(response.data.results || []);
      }
    }
  } catch (e) {
    //
  }
}

function* getControllersForScope(action = {}) {
  const {callback, payload} = action;
  try {
    const response = yield call(requestControllersForScopeAsync, payload);
    if (response?.data) {
      yield put(storeControllersForScope(response.data.results || []));
      if (callback) {
        callback(response.data.results || []);
      }
    }
  } catch (e) {
    //
  }
}

export function* generalSaga() {
  yield takeLatest(actions.REQUEST_ORGANIZATION_ADDRESS, getOrganizationAddress);
  yield takeLatest(actions.REQUEST_SCOPE, getScope);
  yield takeLatest(actions.REQUEST_CONTROLLERS_FOR_SCOPE, getControllersForScope);
}
